/** *@name:index *@author:dingyongya *@date:2023/1/17 10:33 *@update:2023/1/17 10:33 */
<template>
  <div v-clickoutside="handleClickOutside" class="mg-select-tree">
    <el-input
      data-class="mousetrap"
      v-on="$listeners"
      v-bind="$attrs"
      v-model="inputValue"
      class="select-param-input"
      :placeholder="placeholder || $MGUI.i18n.t('请选择')"
      @click.native="handleInput"
      @input="filterInput"
      @blur="handleBlur"
      @mouseenter.native="paramInputHover"
      @mouseleave.native="paramInputOut"
    >
      <i slot="suffix" class="el-input__icon" :class="icon" @click="() => iconClick(icon)" />
    </el-input>
    <div v-show="treeShowFlag" style="width: 100%; position: absolute; z-index: 3333">
      <div class="mg-triangle"><span /></div>
      <div class="mg-drop-down">
        <el-tree
          v-on="$listeners"
          v-bind="$attrs"
          ref="tree"
          :data="treeList"
          :show-checkbox="!$attrs['check-on-click-node']"
          :check-on-click-node="$attrs['check-on-click-node']"
          :filter-node-method="filterNode"
          highlight-current
          :default-checked-keys="defaultCheckedKeys"
          class="mg-drop-down-tree"
          @check="handleCheckChangeTree"
          @check-change="handleCheckChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
  // clickoutside自定义指令，当鼠标点击指令绑定元素的外部时会触发该方法。
  import Clickoutside from 'element-ui/src/utils/clickoutside'
  export default {
    name: 'MgSelectTree',
    directives: { Clickoutside }, // 声明指令
    model: {
      prop: 'value',
      event: 'change',
    },
    props: {
      treeData: {
        type: [Array, Object],
        default: () => [],
      },
      // value监听的是父组件的v-model
      value: {
        type: [String, Array, Number],
        default: () => [] || '',
      },
      placeholder: {
        type: String,
      },
      map: {
        type: Object,
        default: () => {
          return { name: 'name', value: 'id', children: 'children' }
        },
      },
      api: Function,
      queryForm: {
        type: Object,
        default: () => {},
      },
      clearable: { type: Boolean, default: false },
      montageCode: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        defaultCheckedKeys: [],
        treeShowFlag: false,
        selectParam: '',
        inputValue: '',
        icon: 'el-icon-arrow-down',
        treeList: [],
      }
    },
    watch: {
      treeShowFlag(val) {
        this.icon = val ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
      },
      selectParam(val) {
        this.$emit('change', val)
      },
      // treeData: {
      //   handler: function(newVal) {
      //     if (!this.api) {
      //       this.treeList = newVal || []
      //       this.handleRecursion(this.treeList)
      //     }
      //   },
      //   deep: true,
      //   immediate: true,
      // },
      treeList: {
        handler: function () {
          if (!this.value || this.value.length === 0) {
            this.iconClick('el-icon-circle-close')
            this.treeShowFlag = false
          } else {
            this.handleInitValue(this.treeList, this.value)
          }
        },
        deep: true,
        immediate: true,
      },
    },
    created() {
      if (this.api) {
        this.handleApi()
      } else {
        this.treeList = this.treeData
        this.handleRecursion(this.treeData)
      }
    },
    methods: {
      handleBlur() {
        if (this.selectParam === null) {
          this.$emit('change', this.selectParam)
        }
      },
      async handleApi() {
        const { data } = await this.api(this.queryForm)
        this.treeList = data
        this.handleRecursion(this.treeList)
      },
      // 递归数据获取默认值
      handleInitValue(data, value, arr = []) {
        data.forEach((item) => {
          if (Array.isArray(value) && value.includes(item[this.map.value])) {
            this.defaultCheckedKeys = value
            arr.push(item[this.map.name])
            this.inputValue = arr.toString()
          } else if (item[this.map.value] == value) {
            this.inputValue = item[this.map.name]
          }
          if (item[this.map.children] && item[this.map.children].length > 0) {
            this.handleInitValue(item[this.map.children], value, arr)
          }
        })
      },
      // 递归数据为拼接code-name
      handleRecursion(data) {
        data.forEach((item) => {
          if (this.montageCode) {
            item[this.map.name] = `${item[this.map.value]}-${item[this.map.name]}`
          }
          if (item[this.map.children] && item[this.map.children].length > 0) {
            this.handleRecursion(item[this.map.children])
          }
        })
      },
      // 点击外部区域收起下拉框
      handleClickOutside() {
        this.treeShowFlag = false
      },
      // 点击输入框展开/收起下拉框
      handleInput() {
        this.treeShowFlag = !this.treeShowFlag
        this.$emit('click')
      },
      // 输入文字进行模糊查询
      filterInput: function (val) {
        this.treeShowFlag = true
        if (this.treeList.length === 0) return
        this.$refs.tree.filter(val)
        this.selectParam = null
      },
      // 鼠标悬浮，如果由内容的话就显示清除图标
      paramInputHover: function () {
        if (this.selectParam !== '' && this.clearable) {
          this.icon = 'el-icon-circle-close'
        }
      },
      // 鼠标由悬浮离开，如果图标显示的是清除的话，就换成原来的图标
      paramInputOut: function () {
        if (this.icon === 'el-icon-circle-close' && this.clearable) {
          this.icon = this.treeShowFlag ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
        }
      },
      // 点击清除图标时清除输入框的内容
      iconClick: function (icon) {
        if (icon === 'el-icon-circle-close') {
          this.treeShowFlag = false // 由于此事件会同时触发handleInput(),所以将treeShowFlag设为false，防止出现下拉列表
          this.selectParam = ''
          this.inputValue = ''
          this.filterInput(this.selectParam) // 内容清除后显示所有数据
          this.$emit('change', '')
          if (this.treeList.length === 0) return
          this.$refs.tree.setCheckedKeys([])
        } else {
          this.selectParam = ''
          this.inputValue = ''
          this.$emit('change', '')
          this.treeShowFlag = false // 由于此事件会同时触发handleInput(),所以将treeShowFlag设为false，防止出现下拉列表
        }
      },
      // 节点过滤（模糊查询）
      filterNode(value, data) {
        if (!value) return true
        return data.name.indexOf(value) !== -1
      },
      handleCheckChangeTree(checkedNodes, checkedKeys) {
        if (!this.$attrs['check-on-click-node']) {
          this.selectParam = checkedKeys.checkedKeys
          this.inputValue = this.filterArray(this.treeList, checkedKeys.checkedKeys).toString()
        }
      },
      handleCheckChange(data) {
        if (this.$attrs['check-on-click-node']) {
          this.selectParam = data[this.map['value']]
          this.inputValue = data[this.map['name']]
        }
      },
      filterArray(arr, condition) {
        let filteredArr = []
        arr.forEach((element) => {
          if (Array.isArray(element[this.map.children])) {
            filteredArr = filteredArr.concat(this.filterArray(element[this.map.children], condition))
          } else if (condition.includes(element[this.map.value])) {
            filteredArr.push(element[this.map.name])
          }
        })
        return filteredArr
      },
    },
  }
</script>
<style lang="scss" scoped>
  .mg-select-tree {
    width: 100%;
    display: inline-block;
    transition: 0.5s;
    padding: 0;
    .select-param-input {
      width: 100%;
      cursor: pointer;
    }
    ::v-deep(.el-input__inner) {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 18px !important;
      font-style: normal;
    }
    ::v-deep(.el-input__inner::placeholder),
    ::v-deep(.el-input__inner::-webkit-input-placeholder),
    ::v-deep(.el-input__inner::-moz-placeholder),
    ::v-deep(.el-input__inner:-ms-input-placeholder) {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 18px !important;
      line-height: 40px;
      color: #333333 !important;
      font-style: normal;
      opacity: 1 !important;
    }

    ::v-deep(.el-tree-node__label) {
      font-size: 16px;
    }
  }
  .mg-drop-down {
    border-radius: 3px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    box-shadow: 1px 2px 8px 1px rgba(0, 0, 0, 0.2);
  }
  .mg-drop-down .mg-drop-down-tree {
    overflow: auto;
    max-height: 325px;
  }
  .mg-triangle {
    width: 0;
    height: 0;
    border-width: 0 8px 7px;
    border-style: solid;
    border-color: transparent transparent rgb(220, 223, 230);
    margin-left: 60px;
    margin-top: 3px;
    position: relative;
  }
  .mg-triangle span {
    display: block;
    width: 0;
    height: 0;
    border-width: 0 7px 6px;
    border-style: solid;
    border-color: transparent transparent rgb(255, 255, 255);
    position: absolute;
    top: 1px;
    left: -7px;
  }
</style>
